// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-component-container {\n    height: calc(100% - 32px);\n    margin: 16px;\n    margin-top: 72px;\n    background-color: #fff;\n    border: 1px solid rgba(67, 74, 84, 0.1);\n    border-radius: 3px;\n    overflow: auto;\n}\n\n.loading-component-layout-content {\n    height: 100%;\n}", ""]);
// Exports
module.exports = exports;
